const VIRTUAL_ONLY = new Set(["virtual", "virtual_only"]);
const IN_PERSON_ONLY = new Set(["physical", "in_person_only"]);

export function normalizeConsultationPracticeMode(value) {
  const raw = String(value || "").trim().toLowerCase();
  if (VIRTUAL_ONLY.has(raw)) return "virtual_only";
  if (IN_PERSON_ONLY.has(raw)) return "in_person_only";
  return "hybrid";
}

// This is the sole booking-mode matrix for Patient booking and Fola. Inputs
// are canonical authority facts, never route state or a cached profile.
export function resolveConsultationModeAuthority({
  practiceMode,
  evisitEnabled,
  inPersonReady,
  preferredMode = "",
  hasFacilityContext = false,
} = {}) {
  const normalizedPracticeMode = normalizeConsultationPracticeMode(practiceMode);
  // Virtual-only is itself the clinician's operational consultation model.
  // A stale EVisit toggle must never create an impossible no-consultation
  // state; the toggle only governs Hybrid's optional virtual lane.
  const virtualAvailable =
    normalizedPracticeMode === "virtual_only" ||
    (normalizedPracticeMode === "hybrid" && evisitEnabled === true);
  const inPersonAvailable = normalizedPracticeMode !== "virtual_only" && inPersonReady === true;
  const requested = String(preferredMode || "").trim().toLowerCase();

  let mode = "";
  if (requested === "evisit" && virtualAvailable) mode = "evisit";
  else if (requested === "inperson" && inPersonAvailable) mode = "inperson";
  else if (hasFacilityContext && inPersonAvailable) mode = "inperson";
  else if (inPersonAvailable) mode = "inperson";
  else if (virtualAvailable) mode = "evisit";

  return {
    practiceMode: normalizedPracticeMode,
    virtualAvailable,
    inPersonAvailable,
    mode,
    temporarilyUnbookable: !virtualAvailable && !inPersonAvailable,
  };
}
